import React from "react";
import { Helmet } from "react-helmet";

const Title: React.FC<{ value: string }> = ({ value }) => (
  <Helmet>
    <title>{value}</title>
  </Helmet>
);

export default Title;
